import { render } from "./TableMergeCells.vue?vue&type=template&id=dd8f07ca"
import script from "./TableMergeCells.vue?vue&type=script&lang=js"
export * from "./TableMergeCells.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/TableMergeCells.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dd8f07ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dd8f07ca', __exports__)) {
    api.reload('dd8f07ca', __exports__)
  }
  
  module.hot.accept("./TableMergeCells.vue?vue&type=template&id=dd8f07ca", () => {
    api.rerender('dd8f07ca', render)
  })

}


export default __exports__